const PATHS = {
  login: '/',
  teachers: '/teachers',
  workers: '/workers',
  workerDetails: '/workers/:id',
  teacherDetails: '/teachers/:id',
  students: '/students',
  studentsNoPayments: '/one-time-students',
  newStudents: '/new-students',
  studentDetails: '/students/:id',
  debtors: '/debtors',
  paymentProblems: '/payment-problems',
  settings: '/settings',
  profile: '/profile',
  finances: '/finances',
  dashboard: '/dashboard',
  message: '/message',
  archivedStudents: '/archived-students',
  archivedTeachers: '/archived-teachers',
  calendarSync: '/calendar-sync',
  teachersIncomes: '/payouts',
  myStudents: '/my-students',
  panelTopicality: '/topicality',
  studentsToDelete: '/marked-students',
  teacherStats: '/teacher-stats',
  tools: '/tools'
}

export default PATHS
